import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroBanner from './HeroBanner';
import TrendingDestinations from './TrendingDestinations';
import DomesticPackages from './DomesticPackages';
import SpecialPicks from './SpecialPicks';
import InternationalPackages from './InternationalPackages';
import PerfectVacation from './PerfectVacation';
import SellingPackage from './SellingPackage';
import TravelAnimation from './Testimonials';
import { fetchMetadata, API_BASE_URL } from '../utils/api';

function Main() {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const data = await fetchMetadata();
        // Filter for homepage metadata
        const homeMetadata = data.find((item) => item.pageName === 'home');
        if (!homeMetadata) {
          throw new Error('Homepage metadata not found in response');
        }
        setSeoData(homeMetadata);
        setLoading(false);
      } catch (err) {
        console.error('Metadata fetch error:', {
          message: err.message,
          name: err.name,
          stack: err.stack,
        }); // Detailed error logging
        setError(`Failed to load SEO metadata: ${err.message}`);
        setLoading(false);
      }
    };
    loadMetadata();
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'Bluelagoon Travels'}</title>
        <meta
          name='description'
          content={seoData?.description || 'Default description'}
        />
        <meta
          name='keywords'
          content={seoData?.keywords || 'default, keywords'}
        />
        <meta
          name='pageName'
          content={seoData?.pageName || 'Home'}
        />
      </Helmet>
      <HeroBanner />
      <SpecialPicks />
      <TrendingDestinations />
      <DomesticPackages />
      <PerfectVacation />
      <InternationalPackages />
      <SellingPackage />
      <TravelAnimation />
    </>
  );
}

export default Main;
